import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../utils/colors";

interface IProps {
  value?: boolean;
  onClick: () => void;
  disabled?: boolean;
}
const Radio = ({ value = false, onClick, disabled }: IProps) => {
  return (
    <Container
      onClick={() => {
        if (disabled) {
          return;
        }
        onClick();
      }}
    >
      <Bulb style={{ opacity: value ? 1 : 0 }} />
    </Container>
  );
};

export default Radio;

const Container = styled.div`
  cursor: pointer;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  border: 1px solid ${Colors.grey600};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
`;

const Bulb = styled.div`
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background-color: ${Colors.yellow500};
  transition: all 0.2s ease-in-out;
`;
